// Chart.js
import { Bar, Line, Doughnut } from 'vue-chartjs';
import { h } from 'vue';
import {
    Chart as ChartJS, BarElement, LineElement, PointElement,
    ArcElement, CategoryScale, LinearScale, Tooltip, Legend
} from 'chart.js';

ChartJS.register(BarElement, LineElement, PointElement, ArcElement, CategoryScale, LinearScale, Tooltip, Legend);

export const BarChart = {
    components: { Bar },
    props: { chartData: Object, chartOptions: Object },
    render() {
        return h(Bar, { data: this.chartData, options: this.chartOptions })
    }
};

export const LineChart = {
    components: { Line },
    props: { chartData: Object, chartOptions: Object },
    render() {
        return h(Line, { data: this.chartData, options: this.chartOptions })
    }
};

export const DoughnutChart = {
    components: { Doughnut },
    props: { chartData: Object, chartOptions: Object },
    render() {
        return h(Doughnut, { data: this.chartData, options: this.chartOptions })
    }
};